module.exports = __webpack_public_path__ + "static/img/product03-1.4a1341db.png";